export async function readerCall(operation, args) {
    const response = await window.electronAPI.pbreader[operation](args);
    if (!response?.ok) throw new Error(response?.error || 'PbReader unavailable');
    return response.result;
}
